/** The Autopostmate lockup: the mark in white on an accent tile, then the name.
 *  The mark is `public/logo/autopostmate-mark-ink.png` used as a CSS mask, so
 *  the tile's accent follows the theme with no second file. */
export function Logo() {
  return (
    <span className="logo">
      <span className="logo__tile" aria-hidden="true">
        <span className="logo__mark" />
      </span>
      <span className="logo__name">Autopostmate</span>
    </span>
  );
}
